import React from 'react';
import styled from 'styled-components';
import { Close } from '@mui/icons-material';
import TooltipIconButton from "components/TooltipIconButton";
import Logo from '../../Logo';
import useViewerStore from '../../../store-zustand/viewer';
//import { useSelector, useDispatch } from "react-redux";
import { ClearGlobalVariables } from '../../MapView/MapUtils';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 4rem;
  button {
    margin: 0 0 0 1rem;
  }
`;

const SidebarHeader = ({ children, onClose, returnToOriginalPage, edit }) => {
  //Close modal mapbox
  const { viewer, setmapboxvisibility } = useViewerStore();
  //const dispatch = useDispatch();

  const handleClose = () => {
    if (edit === true) {
      returnToOriginalPage();
    } else {
      onClose();
    }
  };
  return (
    <Wrapper>
      <Logo />
      <div>
        {children}
        <TooltipIconButton title="Close" ariaLabel="close" placement="bottom" onClick={handleClose} size={44}>
          <Close />
        </TooltipIconButton>
      </div>
    </Wrapper>
  )
}
export default SidebarHeader;